// import persist from "../../store/persist";

const persist = {
    sGubun: 'T',
};

export const reportUtilType = {
    /**
     * @param articleType : 20:개념, 21: 문항, 22: 활동
     * @param mrkTy : 1:자동, 2:수동, 3:채점불가 (자동1 === 문항, 수동2 === 활동, 채점불가3 === 개념)
     * @param errata : 1:정답, 2:오답, 3:부분정답, 4:채점불가
     * @param eakAt : 응시 미응시
     * @param submAt : 제출 미제출
     * @param isClass : 수업 리포트인가?
     */
    errataType: (
        mrkTy: number,
        errata: number,
        eakAt: string,
        submAt: string,
        isClass?: boolean
    ) => {
        let thumbType = ''; // 왼쪽 썸네일
        let labelStr = ''; // 왼쪽 썸네일 라벨
        let scoreBt = ''; // 왼쪽 썸네일 옆 정오표시 (디테일 화면 전 디폴트 타입)

        // 개념 - 썸네일 에라타x, 기본 썸네일만 적용
        if (mrkTy === 3) {
            return { thumbType: '', labelStr: '', scoreBt: 'feedback score-bt-none' };
        }
        // 문항 - 자동, 수정 전 후 처리를 위해 errata 기반으로 o, x(별), 세모 결정
        else if (mrkTy === 1) {
            if (errata === 1) {
                thumbType = 'feedback fb-correct';
                labelStr = ', 정답';
                scoreBt = 'score-bt-perfect';
            } else if (errata === 2) {
                thumbType = 'feedback fb-incorrect';
                labelStr = ', 오답';
                scoreBt = 'feedback score-bt-zero';
            } else if (errata === 3) {
                thumbType = 'feedback fb-mid';
                labelStr = ', 부분정답';
                scoreBt = 'score-bt-partial';
            } else if (errata === 4) {
                thumbType = 'feedback fb-incorrect';
                labelStr = ', 오답';
                scoreBt = 'feedback score-bt-zero';
            } else {
                thumbType = '';
                labelStr = '';
                scoreBt = '';
            }
        }
        // 활동 - 수동, 채점 여부에 따라 o, x, 세모
        else if (mrkTy === 2) {
            if (errata === 1) {
                thumbType = 'feedback fb-correct';
                labelStr = ', 정답';
                scoreBt = 'score-bt-perfect';
            } else if (errata === 2) {
                thumbType = 'feedback fb-incorrect';
                labelStr = ', 오답';
                scoreBt = 'feedback score-bt-zero';
            } else if (errata === 3) {
                thumbType = 'feedback fb-mid';
                labelStr = ', 부분정답';
                scoreBt = 'score-bt-partial';
            } else if (errata === 4) {
                if (persist.sGubun === 'T') {
                    thumbType = 'feedback fb-edit';
                    labelStr = ', 수정하기';
                    scoreBt = 'score-bt-manual';
                    if (isClass) {
                        thumbType = '';
                        labelStr = ', 수정하기';
                        scoreBt = '';
                    }
                } else {
                    thumbType = '';
                    labelStr = ', 채점 전';
                    scoreBt = '';
                }
            } else {
                thumbType = '';
                labelStr = '';
                scoreBt = '';
            }
        }

        if (eakAt === 'N' && submAt === 'Y') {
            // thumbType = 'feedback fb-incorrect'
            labelStr += ', 미응시';
            // scoreBt = 'feedback score-bt-zero';
        } else if (eakAt === 'Y' && submAt === 'N') {
            thumbType = persist.sGubun === 'T' ? 'feedback fb-edit' : '';
            labelStr += ', 미제출';
            scoreBt = 'score-bt-manual';
        } else if (eakAt === 'N' && submAt === 'N') {
            thumbType = persist.sGubun === 'T' ? 'feedback fb-edit' : '';
            labelStr += ', 미제출, 미응시';
            scoreBt = 'score-bt-manual';
        }

        return { thumbType, labelStr, scoreBt };
    },

    statusType: (status: string, allQstnMrkTyCd?: number, allManualMrkAt?: string) => {
        let scoreStatus = '';
        let criteria = '';
        let stntCriteria = '';
        if (status === '완료' || status === '미완료') {
            scoreStatus = `(${status})`;
            criteria = '(완료/미완료)';
            stntCriteria = '완료/미완료';
            if (allQstnMrkTyCd === 2 || allManualMrkAt === 'Y') {
                scoreStatus = '-점(완료)';
            }
        } else if (status === '점수') {
            scoreStatus = `(${status}점)`;
            criteria = '(점수)';
            stntCriteria = '점수';
            if (allQstnMrkTyCd === 2 || allManualMrkAt === 'Y') {
                scoreStatus = '-점(-)';
            }
        } else if (status === '상' || status === '중' || status === '하') {
            scoreStatus = `(${status})`;
            criteria = '(상/중/하)';
            stntCriteria = '상/중/하';
            if (allQstnMrkTyCd === 2 || allManualMrkAt === 'Y') {
                scoreStatus = '-점(-)';
            }
        } else if (status === '통과' || status === '실패') {
            scoreStatus = `(${status})`;
            criteria = '(통과/실패)';
            stntCriteria = '통과/실패';
            if (allQstnMrkTyCd === 2 || allManualMrkAt === 'Y') {
                scoreStatus = '-점(-)';
            }
        } else {
            stntCriteria = `점수`;
            if (allQstnMrkTyCd === 2 || allManualMrkAt === 'Y') {
                scoreStatus = '-점(-)';
            }
        }
        return { scoreStatus, criteria, stntCriteria };
    },

    listStatusType: (
        status: string,
        score?: number,
        allQstnMrkTyCd?: number,
        allManualMrkAt?: string
    ) => {
        let resultStatus = '';
        if (status === '완료' || status === '미완료') {
            resultStatus = `${status}`;
            if (allQstnMrkTyCd === 2 || allManualMrkAt === 'Y') {
                resultStatus = '완료';
            }
        } else if (status === '점수') {
            resultStatus = `${score}점`;
            if (allQstnMrkTyCd === 2 || allManualMrkAt === 'Y') {
                resultStatus = '-점';
            }
        } else if (status === '상' || status === '중' || status === '하') {
            resultStatus = `${status}`;
            if (allQstnMrkTyCd === 2 || allManualMrkAt === 'Y') {
                resultStatus = '-';
            }
        } else if (status === '통과' || status === '실패') {
            resultStatus = `${status}`;
            if (allQstnMrkTyCd === 2 || allManualMrkAt === 'Y') {
                resultStatus = '-';
            }
        } else {
            resultStatus = `${score}점`;
            if (score === null) {
                resultStatus = `-`;
            }
            // if(allQstnMrkTyCd === 2 || allManualMrkAt === 'Y') {
            //   resultStatus = '-점'
            // }
        }
        return { resultStatus };
    },
};
